import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtmlPipe } from '../../../utils/pipes/safe-html.pipe';

@Component({
  selector: 'supademo',

  imports: [SafeHtmlPipe],
  templateUrl: './supademo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './supademo.component.scss',
})
export class SupademoComponent {
  @Input({ required: true }) iframeUrl: string;
  @Input({ required: true }) iframeTitle: string;
}
